var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "crash-home-game",
      class: { "is-dead": _vm.gameState == _vm.GAME_STATES.Over },
    },
    [
      _c("div", { staticClass: "game" }, [
        _c("div", { ref: "gameBox", staticClass: "game__town" }, [
          _c("canvas", { ref: "gameContainer" }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }